export const STOP_IDS = ['top', 'story', 'moments', 'board', 'cards', 'factions', 'soundtrack']

export const GAME_URL = '/game'

export const GITHUB_URL = 'https://github.com/dashersw/independence'

export const IMPRINT_URL = '/imprint.html'

export const KUNYE_URL = '/kunye.html'

export const TEAM = [
  { handle: 'dashersw', url: 'https://github.com/dashersw' },
  { handle: 'baturyilmaz', url: 'https://github.com/baturyilmaz' },
]
